<template>
  <div class="el-search__wrapp">
    <div class="search-box" :class="{ focusClass: isFocus }" ref="reference">
      <el-dropdown class="my-dropdown" placement="bottom" style="flex: 0 0 auto;-ms-flex: 0 0 auto;"
        @command="handleGroupCommand">
        <div class="my-select">
          <div class="laebl">{{ activeGroupLabel }}</div>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="my-dropdown-menu">
          <el-dropdown-item v-for="item in searchGroups" :key="item.key" :command="item">{{ item.label
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-divider direction="vertical"></el-divider>
      <el-input size="small" class="my-input" :autofocus="true" :clearable="true" @blur="handleBlur"
        @focus="handleFocus" ref="singleInputRef" placeholder="请输入搜索内容" v-model="searchGroupInput"
        v-if="activeGroupType === 'input'" style="flex: 1 1 0;-ms-flex: 1 1 0;" @keyup.enter.native="handleSearch">
      </el-input>
      <keep-alive>
        <dg-search-header v-if="activeGroupType === 'select'" :key="activeGroupKey" keys="key" :label="activeGroupLabel"
          :isMultiple="isMultiple" :propOptions="options || []" :currentKey="activeGroupKey" :params="activeGroupParams"
          :url="activeGroupUrl" @checked="(obj) => handleSearchStatus(obj)">
          <template #trigger>
            <div class="w-[150] leading-[32] aui-ellipsis-1 !t-[13]" v-if="currentSelectedOption">{{
              currentSelectedOption }}</div>
            <div class="w-[150] leading-[32] t-[#cccccc] !t-[13]" v-else>请选择{{ activeGroupLabel }}</div>
          </template>
        </dg-search-header>
      </keep-alive>
      <!-- <el-select filterable size="small" collapse-tags value-key="key" placeholder="请选择" class="my-el-select"
        v-model="selectValue" :multiple="isMultiple" :reserve-keyword="true" style="flex: 1 1 0;-ms-flex: 1 1 0;"
        v-if="activeGroupType === 'select' && update">
        <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item">
        </el-option>
      </el-select> -->
      <el-divider class="ml0" direction="vertical"></el-divider>
      <el-tooltip class="item" effect="dark" content="搜索" placement="top">
        <i class="el-icon-search cursor-pointer" @click.self.stop="handleSearch"></i>
      </el-tooltip>
    </div>
  </div>
</template>

<script type="text/babel">
import DgSearchHeader from './dg-search-header.vue'
export default {
  name: 'DgSearchInput',
  componentName: 'DgSearchInput',
  props: {
    // 字段筛选[{ key: "字段key",label: "字段名称" }]
    searchGroups: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  components: {
    DgSearchHeader
  },
  watch: {
    searchGroups: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal.length) {
          this.activeGroupLabel = newVal[0].label || '';
          this.activeGroupKey = newVal[0].key || '';
          this.activeGroupType = newVal[0].type || '';
          this.activeGroupParams = newVal[0].params || {};
          this.activeGroupUrl = newVal[0].url || '';
          this.isMultiple = newVal[0].isMultiple || false;
          this.options = newVal[0].options || [];
        }
      }
    },
    isMultiple() {
      this.update = false;
      setTimeout(() => {
        this.update = true;
      }, 50);
    }
  },
  computed: {
    // currentSelectedOption() {
    //   if (this.options.length && this.selectValue.length) {
    //     return this.options.filter((item) => this.selectValue.includes(item.key)).map((item) => item.value).toString();
    //   }
    //   return '';
    // }
  },
  data() {
    return {
      isFocus: false,
      activeGroupLabel: '',
      activeGroupKey: '',
      activeGroupType: '',
      activeGroupUrl: '',
      activeGroupParams: {},
      searchGroupInput: '',
      searchParams: [],
      selectValue: [],
      isMultiple: false,
      options: [],
      update: true,
      currentSelectedOption: '',
    };
  },
  methods: {

    handleSearchStatus(obj) {
      const { isCheckEdItem } = obj;
      this.currentSelectedOption = isCheckEdItem.map((item) => item.value).toString() || '';
      this.selectValue = isCheckEdItem || [];
      this.handleSearch();
    },

    // 搜索图标事件
    handleSearch() {
      switch (this.activeGroupType) {
        case 'input':
          this.handleSearchInput();
          break;
        case 'select':
          this.handleSearchSelect();
          break;
        default:
          this.handleSearchInput();
      }
      this.$emit('handleMultipleSearch', this.searchParams);
    },

    // 判断是否重复搜索
    handlePreCondition() {
      const index = this.searchParams.findIndex((item) => item.key === this.activeGroupKey);
      return { isExist: index > -1, index };
    },

    // 文本搜索
    handleSearchInput() {
      const { isExist, index } = this.handlePreCondition();
      if (isExist) {
        if (this.searchGroupInput.length) {
          this.searchParams[index].value = this.searchGroupInput;
        } else {
          this.searchParams.splice(index, 1);
        }
      } else {
        if (this.searchGroupInput) {
          this.searchParams.push({
            key: this.activeGroupKey,
            keyName: this.activeGroupLabel,
            value: this.searchGroupInput,
            type: 'input'
          });
        }
      }
    },

    // 下拉框搜索
    handleSearchSelect() {
      const { isExist, index } = this.handlePreCondition();
      if (isExist) {
        let isEmpty = Array.isArray(this.selectValue) ? this.selectValue.length : this.selectValue;
        if (isEmpty) {
          this.searchParams[index].value = this.selectValue;
        } else {
          this.searchParams.splice(index, 1);
        }
      } else {
        this.searchParams.push({
          key: this.activeGroupKey,
          keyName: this.activeGroupLabel,
          value: this.selectValue,
          type: 'select',
          isMultiple: this.isMultiple
        });
      }
    },

    handleFocus() {
      this.isFocus = true;
    },
    handleBlur() {
      this.isFocus = false;
    },
    // 组合筛选框
    handleGroupCommand(command) {
      if (this.activeGroupKey === command.key) return;
      this.activeGroupKey = command.key;
      this.activeGroupLabel = command.label;
      this.activeGroupType = command.type;
      this.activeGroupParams = command.params || {};
      this.activeGroupUrl = command.url || '';
      this.isMultiple = command.isMultiple || false;
      this.options = command.options || [];
      const index = this.searchParams.findIndex((item) => item.key === command.key);
      if (this.activeGroupType === 'input') {
        if (this.searchParams.length && index > -1) {
          this.searchGroupInput = this.searchParams[index].value || '';
        } else {
          this.searchGroupInput = '';
        }
      }
      if (this.activeGroupType === 'select') {
        if (this.searchParams.length && index > -1) {
          this.selectValue = this.searchParams[index].value;
          this.currentSelectedOption = this.selectValue.map((item) => item.value).toString() || '';
        } else {
          this.selectValue = [];
          this.currentSelectedOption = ''
        }
      }
    },
    // 清除搜索条件
    handleClear() {
      this.searchParams = [];
      this.searchGroupInput = '';
      this.selectValue = null;
      this.currentSelectedOption = ''
      this.$emit('handleMultipleSearch', this.searchParams);
    },
    // 清除单个搜索条件
    handleClearItem(key) {
      const index = this.searchParams.findIndex((item) => item.key === key);
      if (index > -1) {
        const item = this.searchParams[index];
        if (item.type === 'input') {
          this.searchGroupInput = '';
        }
        if (item.type === 'select') {
          this.selectValue = item.isMultiple ? [] : '';
          this.currentSelectedOption = ''
        }
        this.searchParams.splice(index, 1);
        this.$emit('handleMultipleSearch', this.searchParams);
      }
    }
  },
};
</script>

<style lang="less" scoped>
// @import "~@/assets/css/var.less";

.el-search__wrapp {
  position: relative;

  .focusClass {
    border-color: @theme !important;
  }

  /deep/ .search-box {
    background-color: #FAFAFC;
    display: flex;
    align-items: center;
    border: 1px solid #C3CAD9;
    border-radius: 2px;
    height: 32px;
    box-sizing: border-box;
    padding-right: 8px;
    overflow: hidden;

    &:hover,
    :focus-within,
    :focus-visible,
    :active {
      border-color: @theme;
      outline: none !important;
    }

    /deep/ .el-input__inner {
      border: none !important;
      background-color: transparent;
    }

    /deep/ .my-select {
      height: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;

      .laebl {
        width: auto;
        height: 100%;
        line-height: 30px;
        font-size: 12px;
        color: #606266;
        box-sizing: border-box;
        padding-left: 8px;
        margin-right: 4px;
      }
    }

    /deep/ .my-el-select {
      .el-select__tags .el-tag {
        max-width: 98px;
      }
    }

    /deep/ .my-input {
      .el-input__inner {
        padding-left: 0;
        padding-right: 56px;
      }

      .el-input__suffix {
        cursor: pointer;
        color: #909399;

        .el-icon-search {
          &:hover {
            color: @theme;
          }
        }
      }
    }

    .ml0 {
      margin-left: 0;
    }

    .submit-btn {
      color: @theme;
      font-size: 12px;
      cursor: pointer;
      line-height: 30px;
      padding-right: 10px;
    }
  }

  /deep/ .box-card {
    width: 400px;
    position: absolute;
    z-index: 999;
    top: -10px;
    right: -6px;

    /deep/ .search-box {
      padding-right: 10px;

      /deep/ .my-input {
        .el-input__inner {
          padding-left: 0;
          padding-right: 30px;
        }
      }

      /deep/ .el-input-group__append {
        background-color: transparent !important;
        border: none;
        border-radius: 0;
        padding: 0 16px;
      }

      .switch-icon {
        transform: rotate(-90deg);
      }
    }

    /deep/ .el-card__body {
      box-sizing: border-box;
      padding: 12px;
    }

    /deep/ .content {
      margin-top: 12px;
      box-sizing: border-box;
      padding: 8px;
      width: 100%;
      height: 146px;
      overflow-y: scroll;
      background: #EBEDF0;
      border-radius: 2px;
      border: 1px solid #C3CAD9;

      .item {
        font-size: 12px;
        color: #606266;
        line-height: 20px;
      }
    }

    /deep/ .btns {
      margin-top: 12px;
      text-align: center;

      button {
        padding: 7px 10px !important;
      }
    }
  }
}

/deep/ .my-dropdown-menu[x-placement^="bottom"] {
  max-height: 300px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    /* 血槽宽度 */
    width: 1px;
    height: 1px;
  }
}
</style>